import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";
import { t } from "@/lib/i18n";
import { toast } from "sonner";

export const KINDS = ["wedding", "puja", "reunion", "birthday", "festival", "other"];
const empty = { title: "", kind: "wedding", date: "", time: "", location: "", description: "" };
const F = ({ label, children }) => <div className="space-y-1.5"><Label className="text-[#52635B]">{label}</Label>{children}</div>;

export const EventDialog = ({ event, onClose, onSaved }) => {
  const [f, setF] = useState(event ? { ...empty, ...event } : empty);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    const body = { title: f.title, kind: f.kind, date: f.date, time: f.time, location: f.location, description: f.description };
    try {
      if (event) await api.put(`/events/${event.event_id}`, body);
      else await api.post("/events", body);
      toast.success(t("Save event"));
      onSaved();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="sm:max-w-xl max-h-[90vh] overflow-y-auto" data-testid="event-dialog">
        <DialogHeader><DialogTitle className="font-serif">{event ? t("Edit event") : t("New event")}</DialogTitle></DialogHeader>
        <form onSubmit={save} className="space-y-4">
          <F label={t("Event name")}><Input required value={f.title} onChange={set("title")} className="h-11 rounded-xl" data-testid="event-title-input" /></F>
          <div className="grid grid-cols-2 gap-3">
            <F label={t("Type")}>
              <select value={f.kind} onChange={set("kind")} className="w-full h-11 rounded-xl border border-[#E5DEC9] bg-white px-3 text-sm capitalize" data-testid="event-kind-select">
                {KINDS.map((k) => <option key={k} value={k}>{t(k)}</option>)}
              </select>
            </F>
            <F label={t("Date")}><Input required type="date" value={f.date} onChange={set("date")} className="h-11 rounded-xl" data-testid="event-date-input" /></F>
            <F label={t("Time")}><Input type="time" value={f.time} onChange={set("time")} className="h-11 rounded-xl" data-testid="event-time-input" /></F>
            <F label={t("Place")}><Input value={f.location} onChange={set("location")} className="h-11 rounded-xl" data-testid="event-location-input" /></F>
          </div>
          <F label={t("Details")}><Textarea value={f.description} onChange={set("description")} className="rounded-xl" data-testid="event-description-input" /></F>
          <Button type="submit" disabled={busy} className="rounded-full bg-[#1E3A2B] hover:bg-[#162C20] w-full h-11" data-testid="event-save-btn">{event ? t("Save event") : t("Create event")}</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
